import { Button } from "@mui/material";
import "./index.css";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SendIcon from "@mui/icons-material/Send";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { DateRange, DeleteOutline, Print } from "@mui/icons-material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import MenuIcon from "@mui/icons-material/Menu";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SecurityIcon from "@mui/icons-material/Security";
import AlarmIcon from "@mui/icons-material/Alarm";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import VisibilityIcon from "@mui/icons-material/Visibility";

const CustomButton = (props) => {
  const { btnType, btnClass, action } = props;
  const getButtonClass = () => {
    switch (btnType) {
      case "terinary":
        return "terinary";
      case "secondary":
        return "secButton";
      case "danger":
        return "danger";
      default:
        return "primButton";
    }
  };
  const getIcon = (action) => {
    switch (action) {
      case "EYE":
        return <VisibilityIcon />;
      case "PRINT":
        return <Print />;
      case "SAVE":
        return <SaveIcon />;
      case "LOGOUT":
        return <LogoutIcon />;
      case "PDF":
        return <PictureAsPdfIcon />;
      case "EXCEL":
      case "TABLE":
        return <BorderAllIcon />;
      case "MENU":
        return <MenuIcon />;
      case "DONE":
        return <TaskAltIcon />;
      case "NEW":
        return <AddIcon />;
      case "CANCEL":
        return <CloseIcon />;
      case "EXPORT":
        return <ExitToAppIcon />;
      case "IMPORT":
        return <ImportExportIcon />;
      case "FILTER":
        return <FilterAltIcon />;
      case "BACK":
        return <ArrowBackIcon />;
      case "NEXT":
        return <ArrowForwardIcon />;
      case "DATE":
        return <DateRange />;
      case "SEND":
        return <SendIcon />;
      case "VERIFY":
        return <VerifiedUserIcon />;
      case "DELETE":
        return <DeleteOutline />;
      case "UPLOAD":
        return <FileUploadIcon />;
      //
      case "MASTER":
        return <AddCircleOutlineIcon />;
      case "ROLES":
        return <SecurityIcon />;
      case "REMINDERS":
        return <AlarmIcon />;
      case "OTHERS":
        return <SettingsSuggestIcon />;
      //
      case "KEYBOARD_LEFT":
        return <KeyboardArrowRightIcon />;
      case "KEYBOARD_RIGHT":
        return <KeyboardArrowLeftIcon />;
      default:
        break;
    }
  };
  return (
    <div
      className={`btnWrpr ${btnClass || ""} ${getButtonClass()}  ${
        props.disabled ? "btn-disabled" : ""
      }`}
    >
      <Button
        className={`${props.sdize} ${props.className}`}
        variant={props.btnType === "secondary" ? "outlined" : "contained"}
        onClick={props.onClick}
        type={props.type}
        endIcon={!props.isStartIcon && getIcon(action)}
        startIcon={props.isStartIcon && getIcon(action)}
        size={props.size}
        disabled={props.disabled}
        color={props.color}
      >
        {props.label}
      </Button>
    </div>
  );
};

export default CustomButton;
